import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { DiscountDescriptions } from '../components/DiscountDescriptions.js';
import { useCartSettings } from '../../../context/CartSettings/context.js';
import { useCart } from '../../../context/Cart/context.js';

const DiscountDescriptionsContainer = ()=>{
    const settings = useCartSettings();
    const { cart  } = useCart();
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            promotionTitle: getLabel('cart.cart.promotion.title')
        })
    , [
        getLabel
    ]);
    if (!settings.showCartDiscountDescriptions || !cart || !(cart.discountDescriptions.length > 0)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(DiscountDescriptions, {
        descriptions: cart.discountDescriptions,
        labels: labels
    });
};

export { DiscountDescriptionsContainer };
//# sourceMappingURL=DiscountDescriptionsContainer.js.map
